import { Fragment, useState } from "react";
import { ImSpinner9 } from "react-icons/im";
import { shuffle } from "shuffle-seed";

export default function AcceptModal({
  answers,
  data,
  onOk = () => {},
  phone_number,
}) {
  const [loading, setLoading] = useState(false);
  return (
    <>
      <button
        className="btn text-lg mt-5 p-2 px-3 duration-300 shadow-xl hover:bg-primary-700 bg-primary-600 text-white !rounded-lg !font-extralight !font-dana-normal disabled:bg-slate-300 disabled:text-white"
        onClick={() => document.getElementById("my_modal_1").showModal()}
      >
        ثبت پاسخنامه
      </button>
      <dialog id="my_modal_1" className="modal modal-middle sm:modal-middle">
        <div className="modal-box">
          {loading ? (
            <div className=" text-center text-secondary-400 items-center gap-3 flex flex-col">
              <ImSpinner9 className="animate-spin" fontSize={48} />
              درحال ثبت پاسخنامه
            </div>
          ) : (
            <>
              <h3 className="font-bold text-lg">یادآوری!</h3>
              <p className="py-4">شما به سوالات زیر پاسخ نداده اید</p>
              <div>
                {data.map((item) => (
                  <Fragment key={"course_accept" + item.id}>
                    <div className="divider divider-start !text-sm">
                      {item.course.title}
                    </div>
                    <div className="flex flex-row flex-wrap items-center gap-2">
                      {shuffle(item.questions, phone_number).map((q, index) => (
                        <span
                          key={"course_q_accept" + q.id}
                          className={
                            Boolean(answers[q.id] < 5)
                              ? "hidden underline"
                              : "block underline"
                          }
                        >
                          {index + 1}
                        </span>
                      ))}
                    </div>
                  </Fragment>
                ))}
              </div>
              <div className="modal-action gap-2">
                <form method="dialog">
                  <button className="btn btn-sm btn-circle btn-ghost absolute left-2 top-2">
                    ✕
                  </button>
                  {/* if there is a button in form, it will close the modal */}
                  <button className="btn btn-error text-white">
                    بررسی مجدد
                  </button>
                </form>
                <button
                  onClick={() => {
                    setLoading(true);
                    onOk();
                  }}
                  className="btn max-w-[120px] btn-primary bg-primary-500 text-white"
                >
                  ثبت پاسخنامه
                </button>
              </div>
            </>
          )}
        </div>
      </dialog>
    </>
  );
}
